// extracted by mini-css-extract-plugin
export default {"wrap":"Zo-z","logoContainer":"_o-z","brandImg":"ap-z","logoImg":"bp-z","logoButton":"cp-z"};